<script>
import CourseSectionsComponent from '../../features/boxes/CourseSectionsComponent';
import CourseSubjectsView from './CourseSubjectsView';

export default {
  components: {
    'course-subjects-view': CourseSubjectsView,
  },
  extends: CourseSectionsComponent,
};
</script>

<template>
  <div class="course_sections_wrapper">
    <div
      v-if="!courseSections || courseSections.length === 0"
      class="course_sections_empty"
    >
      <div class="empty_icon_box">
        <i class="uil uil-folder-exclamation" />
      </div>
      <p class="empty_title">
        No hay secciones disponibles
      </p>
      <p class="empty_desc">
        No se encontraron temas o secciones para la especialidad seleccionada.
      </p>
    </div>

    <el-collapse
      v-else
      class="course_sections_collapse"
    >
      <el-collapse-item
        v-for="(section, sectionIndex) in orderSections(courseSections)"
        :key="sectionIndex"
        :name="sectionIndex"
      >
        <template #title>
          <div class="section_title_bar">
            <div class="section_title_left">
              <span class="section_icon_badge">
                <i class="uil uil-folder-open" />
              </span>
              <span class="section_name">{{ section.title }}</span>
            </div>
            <div class="section_title_right">
              <span class="section_count_chip">
                <i class="uil uil-book-open" /> {{ section.getTotalCourseSubjects() }} Temas
              </span>
            </div>
          </div>
        </template>
        <course-subjects-view :section="section" />
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
